import React, {useEffect, useState} from 'react';

import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import {SetupPageQube} from './SetupPageQube';
import {ProductSelection} from '../../signup/ProductSelection';
import SetupPageQubeLite from './SetupPageQubeLite';
import {doTrack} from '../../utils/utils';
import {fetchWorkspace} from '../../utils/api.utils';
import _ from 'lodash';

let currentReleaseStage = 'development';

if (process.env.VITE_IS_PRODUCTION  ==='true') {
  currentReleaseStage = 'production';
} else if (process.env.VITE_IS_TEST_MODE  ==='true') {
  currentReleaseStage = 'test';
} else if (!process.env.VITE_IS_DEVELOPMENT  ==='true') {
  currentReleaseStage = 'staging';
}

const bugsnagClient = bugsnag(
  {
    apiKey: '45a754d74f2e667486a396a94a95cac5',
    notifyReleaseStages:
      ['production', 'staging'],
    releaseStage:
    currentReleaseStage,
  });
bugsnagClient.use(bugsnagReact, React);
/**
 * Actual Authentication happens via Slack.
 * Once authenticated the user is available via devise.
 * The office.html.erb file contains a div with the currentUserId.
 * If that field has a valid value we can assume we have a user.
 */
export const SetupPage = () => {
  const ErrorBoundary = bugsnagClient.getPlugin('react');

  const [display, setDisplay] = React.useState('selection');

    useEffect(() => {
        const hasToken = _.includes(window.location.href, 'token');
        const hasEmail = _.includes(window.location.href, 'email');

        if (hasToken || hasEmail) {
            setDisplay('qube');
        }
    }, []);


    const [username, setUsername] = useState('');
    const [zoomError, setZoomError] = useState(false);
    const [suggestedEmail, setSuggestedEmail] = useState('');
    const [suggestedToken, setSuggestedToken] = useState('');
    const [slackError, setSlackError] = useState(false);
    const [slackUnhappy, setSlackUnhappy] = useState(false);
    const [hasUserName, setHasUserName] = useState(false);
    const [subdomain, setSubdomain] = useState('');
    const [currentCircleIndex, setCurrentCircleIndexInState] = useState(0);
    const [completedIdxs, setCompletedIdx] = useState([]);
    const [steps, setSteps] = useState([1, 2, 3, 4]);
    const [token, setToken] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [linkExpired, setLinkExpired] = useState(false);
    const currentDomain = window.location.host;

  const getCurrentStateOfAffairs = () => {
    const params = new URLSearchParams(window.location.search);
    const hasSlackError = _.includes(window.location.href, 'slack_failure') && params.get('slack_failure') === 'true';
    const slackUnhappy = _.includes(window.location.href, 'slack_token_failure') && params.get(
      'slack_token_failure') === 'true';
    const hasZoomError = _.includes(window.location.href, 'zoom_failure') && params.get('zoom_failure') === 'true';
    const suggestedEmail = _.includes(window.location.href, 'suggested_email') && params.get('suggested_email');
    const suggestedToken = _.includes(window.location.href, 'suggested_token') && params.get('suggested_token');
    ///   const workspaceGenerated =  _.includes(window.location.href, 'workspaceGenerated') &&
    // params.get('workspaceGenerated');
    setSuggestedEmail(suggestedEmail);
    setSuggestedToken(suggestedToken)

    setZoomError(hasZoomError);
    setSlackError(hasSlackError);
    setSlackUnhappy(slackUnhappy);

    const existingToken = params.get('token');
    const existingUsername = params.get('email');
    setToken(existingToken);

    setUsername(existingUsername);
    setHasUserName(true);
    setErrorMessage(null);
    return fetchWorkspace({
      email: existingUsername,
      token: existingToken,
    }).then(response => {
      const qubeLite = response.data.data.attributes.lite;
      const hasSlack = response.data.data.attributes.slack_connected;
      const hasZoom = response.data.data.attributes.zoom_connected;
      const hasItAll = response.data.data.attributes.payment_connected;
      const generated = response.data.data.attributes.generated; //|| workspaceGenerated;
      setSubdomain(response.data.data.attributes.subdomain);
      const suggestedSize = response.data.data.attributes.size;
      if (!_.isNil(suggestedSize)) {
        setOfficeSize(suggestedSize);
      }

      if (qubeLite) {
        setDisplay('qubeLite');
        doTrack('Workspace setup - in progress', { hasZoom, generated, token, username });
        const completedIdx = [1];

        if (hasZoom) {
          completedIdx.push(2);
        }
        if (hasItAll) {
          completedIdx.push(3);
        }

        setCompletedIdx(completedIdx);

        if (generated) {
          getItDone();
        } else if (!hasZoom) {
          setCurrentCircleIndexInState(2);

        } else if (hasZoom && !hasItAll) {
          setCurrentCircleIndexInState(3);
        }

      } else {
        doTrack('Workspace setup - in progress', { hasSlack, hasZoom, generated, token, username });
        setDisplay('qube');
        const completedIdx = [1];
        if (hasSlack) {
          completedIdx.push(2);
        }
        if (hasZoom) {
          completedIdx.push(3);
        }
        if (hasItAll) {
          completedIdx.push(4);
        }

        setCompletedIdx(completedIdx);

        if (generated) {
          getItDone();
        } else if (hasSlack && !hasZoom) {
          setCurrentCircleIndexInState(3);

        } else if (hasZoom && !hasItAll) {
          setCurrentCircleIndexInState(4);
        }
      }
    }).catch((error) => {
      if (error.data && error.data.errors && error.data.subdomain) {
        setLinkExpired(true);
        setSubdomain(error.data.subdomain);
      } else {
        if (error.data) {
          setErrorMessage(error.data.errors);
        } else {
          setErrorMessage(error.errors);
        }
      }
    });
  };

  // if email and token in url load workspace:
  useEffect(() => {
    //   const hasToken = _.includes(window.location.href, 'token');
    const hasEmail = _.includes(window.location.href, 'email');

    if (hasEmail) {
      setCurrentCircleIndexInState(2);
      setCompletedIdx([1]);
      getCurrentStateOfAffairs();
    }
  }, []);

  return (
    <ErrorBoundary>
      <div className="logoCorner" />
      {linkExpired
        ?
        <div className="height-maximum flexRowContainer flexCenter setup">
          <h1>This link is no longer valid - the workspace you are trying to access already exists.</h1>
          <h1><a href={'https://' + subdomain + '.' + currentDomain}
            className="white pl10 pr10"
            target={'_blank'}>{'https://' + subdomain + '.' + currentDomain} </a></h1>
        </div>
        :
        <div className="height-maximum flexRowContainer flexCenter setup">
          <div className={'mb20 width-700'}>
            <h1>Get started</h1>
            You're just a few steps away from creating a workspace for you and your colleagues in qube!
          </div>
          {display === 'selection' && <ProductSelection selectProduct={(product) => {
            setDisplay(product);
            if (product === 'qubeLite') {
              setCurrentCircleIndexInState(1);
            }
            doTrack('Product Selected', { product });
          }} />}
          {display === 'qube' &&
          <SetupPageQube hasUserName={hasUserName} subdomain={subdomain} suggestedToken={suggestedToken}
            suggestedEmail={suggestedEmail} slackError={slackError} slackUnhappy={slackUnhappy}
            setHasUserName={setHasUserName} zoomError={zoomError}
            currentCircleIndex={currentCircleIndex} steps={steps}
            setCurrentCircleIndexInState={setCurrentCircleIndexInState}
            completedIdxs={completedIdxs}
            setCompletedIdx={setCompletedIdx} username={username} setUsername={setUsername}
            token={token} setSubdomain={setSubdomain} setSteps={setSteps} setToken={setToken}
            setErrorMessage={setErrorMessage} errorMessage={errorMessage} />}
          {display === 'qubeLite' &&
          <SetupPageQubeLite hasUserName={hasUserName} subdomain={subdomain} suggestedToken={suggestedToken}
            suggestedEmail={suggestedEmail}
            setHasUserName={setHasUserName} zoomError={zoomError}
            currentCircleIndex={currentCircleIndex} steps={steps}
            setCurrentCircleIndexInState={setCurrentCircleIndexInState}
            completedIdxs={completedIdxs}
            setErrorMessage={setErrorMessage} errorMessage={errorMessage}
            setCompletedIdx={setCompletedIdx} username={username} setUsername={setUsername}
            token={token} setSubdomain={setSubdomain} setSteps={setSteps}
            setToken={setToken} />}
        </div>
      }
    </ErrorBoundary>
  );
};

export default SetupPage;
